var requireObjectCoercible = require('../internals/require-object-coercible');

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/to-object.js
// module id = 132
// module chunks = 0